import { WithTranslation, withTranslation } from 'react-i18next';
import { styled } from 'styled-components';
import { Loader, Typography } from '@vivaahealth/design-system';

import styles from './uploading.module.css';

import greenCheckCircle from '../../../../../../assets/green-check-circle.svg';

interface UploadingProps extends WithTranslation {
  completed?: boolean;
  message: string;
}

const StyledLoader = styled(Loader)`
  max-width: 320px;
  text-align: center;
  margin: auto;
`;

const Uploading = ({ completed = false, message, t }: UploadingProps) => {
  return (
    <div className={styles['status-card']}>
      {completed ? (
        <div className={styles['status-card-message-wrapper']}>
          <img alt={t('success')} src={greenCheckCircle} />
          <Typography variant="title-large" bold>
            {t('verificationSuccess')}
          </Typography>
        </div>
      ) : (
        <StyledLoader label={message} subLabel={t('processingTakesAWhile')} />
      )}
    </div>
  );
};

export default withTranslation('processing')(Uploading);
